<template>
  <div
    v-if="totalIncome !== '0.00'"
    class="d-flex flex-column justify-content-center align-items-center"
  >
    <p class=" text-center text-primary">
      Total Income : {{ totalIncome }}
    </p>
    <!-- <apexchart
      type="pie"
      :options="chartOptions"
      :series="seriesData"
    /> -->
  </div>
  <div v-else>
    <p class="py-2 text-center text-primary">
      No Income from {{ officeName }} yet!
    </p>
  </div>
</template>

<script>
// import VueApexCharts from 'vue-apexcharts'

export default {
  // components: {
  //   apexchart: VueApexCharts,
  // },
  props: {
    sources: {
      type: Array,
      default: () => [],
    },
    totalIncome: {
      type: String,
      default: () => '0.00',
    },
    officeName: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    seriesData() {
      return this.sources.map(source => source.total_income)
    },
    labelsData() {
      return this.sources.map(source => `(${source.source}:  ${(source.total_income)})`)
    },
    chartOptions() {
      return {
        chart: {
          type: 'pie',
        },
        labels: this.labelsData,
        responsive: [
          {
            breakpoint: 2550,
            options: {
              chart: {
                width: 520,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 320,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      }
    },
  },
}
</script>
